module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module"
  }, [(_vm.selfRunGoodsList.length > 0) ? _c('goodsList', {
    attrs: {
      "list": _vm.selfRunGoodsList,
      "title": "自营优品",
      "subTitle": "品牌好货放心买",
      "isShowBg": true,
      "url": "/self-owned-mall"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newDailyGoodsList.length > 0) ? _c('goodsList', {
    attrs: {
      "list": _vm.newDailyGoodsList,
      "title": "每日新品",
      "subTitle": "好货常换  惊喜不断",
      "isShowBg": false,
      "url": '/recommend-goods?type=6'
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6075d2d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/banner-square/index.vue
// module id = 1616
// module chunks = 1